<div class="flex flex-col lg:flex-row">
  <!-- Left filter rail -->
  <aside
    class="w-full shrink-0 border-b border-themed lg:w-96 lg:border-b-0 lg:border-r"
    data-testid="hr-tools-filter-panel"
  >
    <app-hr-tool-filter />
  </aside>

  <!-- Right content pane -->
  <main class="min-w-0 flex-1 p-5 md:p-8">
    <div class="mb-6">
      <div class="flex items-start justify-between gap-4">
        <div>
          @if (isToolsOverview()) {
            <p class="text-green mb-1 text-[10px] font-semibold uppercase tracking-[0.35em]">
              {{ 'hrTool.eyebrowProducts' | transloco }}
            </p>
          } @else {
            <p class="text-button-red mb-1 text-[10px] font-semibold uppercase tracking-[0.35em]">
              {{ 'hrTool.eyebrow' | transloco }}
            </p>
          }
          <h1
            class="mb-3 text-2xl font-bold tracking-tight md:text-3xl"
            [attr.data-testid]="'hr-tool-heading'"
          >
            {{ 'hrTool.heading' | transloco }}
          </h1>
        </div>

        <div class="hr-view-toggle" data-testid="hr-overview-toggle">
          <button
            type="button"
            class="hr-view-toggle__option"
            [class.hr-view-toggle__option--active-providers]="isProvidersOverview()"
            (click)="setOverviewMode('providers')"
            data-testid="hr-overview-toggle-providers"
          >
            {{ 'hrTool.overview.providers' | transloco }}
          </button>
          <button
            type="button"
            class="hr-view-toggle__option"
            [class.hr-view-toggle__option--active-products]="isToolsOverview()"
            (click)="setOverviewMode('tools')"
            data-testid="hr-overview-toggle-tools"
          >
            {{ 'hrTool.overview.products' | transloco }}
          </button>
        </div>
      </div>

      <app-hr-tool-info-box />

      <div class="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <!-- Anwendungstyp legend / toggle -->
        <div class="flex flex-wrap items-center gap-2 text-xs">
          @for (type of applicationTypes; track type) {
            <button
              type="button"
              class="hr-legend-chip"
              [class.hr-legend-chip--active]="isApplicationTypeActive(type)"
              (click)="toggleApplicationType(type)"
              [attr.data-testid]="'hr-legend-' + type"
            >
              <i [class]="applicationTypeIcon(type)"></i>{{ applicationTypeLabel(type) }}
            </button>
          }
        </div>

        <div class="flex items-center gap-3">
          <app-global-search
            testId="hr-tools-search"
            [placeholderKey]="searchPlaceholderKey()"
            (searchValue)="onSearchChange($event)"
          />
          @if (isToolsOverview()) {
            <span class="whitespace-nowrap text-xs text-muted-color" data-testid="hr-tool-count">
              {{ toolCount() }} {{ 'hrTool.overview.products' | transloco }}
            </span>
          } @else {
            <span
              class="whitespace-nowrap text-xs text-muted-color"
              data-testid="hr-provider-count"
            >
              {{ providerCount() }} {{ 'hrTool.overview.providers' | transloco }}
            </span>
          }
        </div>
      </div>
    </div>

    @if (isToolsOverview()) {
      <app-hr-tool-overview />
    } @else {
      <app-hr-tool-selection />
    }
  </main>
</div>
